import { render, staticRenderFns } from "./ActivityTemplatePage.vue?vue&type=template&id=fd83f5dc&scoped=true"
import script from "./ActivityTemplatePage.vue?vue&type=script&lang=js"
export * from "./ActivityTemplatePage.vue?vue&type=script&lang=js"
import style0 from "./ActivityTemplatePage.vue?vue&type=style&index=0&id=fd83f5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd83f5dc",
  null
  
)

export default component.exports